import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';

import {ConfigService} from './config.service';
import {Title} from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DomainService {

  private valid: boolean;
  private domain: any;

  constructor(private http: Http,
              private configService: ConfigService,
              private titleService: Title) {
  }

  init(): Promise<any> {

    let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').public.domain.details.api;
    let headers = this.getBaseHeaders();

    let requestOptions = new RequestOptions({headers: headers});

    return this.http.get(url, requestOptions)
      .map(response => response.json())
      .toPromise()
      .then(body => {
        this.valid = true;
        this.domain = body.data;

        if (this.titleService.getTitle() === 'Solar')
          this.titleService.setTitle(this.domain.buyerName);
      })
      .catch(err => {
        console.log('Invalid domain');
        this.valid = false;
      });
  }

  getBanner(): Observable<string> {
    return Observable.of(this.domain.brandedPortalBanner).map(url => `url(${url})`);
  }

  parseDomain(): string {

    let rootDomains = ['.dev.congolo.com', '.test.congolo.com', '.itpx.one', '.stage.congolo.com', '.congolo.com', '.campus.itpreneurs.com', '.leapestpreview.com' ,'.leapest.com', '.edcastmarketplace.com'];
    let domain = window.location.hostname;

    rootDomains.forEach(function (rd) {
      domain = domain.replace(rd, '');
    });

    return domain;
  }

  getDomain(): any {
    return this.domain;
  }

  isValidDomain(): boolean {
    return this.valid;
  }

  allowSelfRegister(): boolean {
    return this.domain.selfRegistration;
  }

  getBaseHeaders(): Headers {
    return new Headers({
      'Content-Type': 'application/json',
      'xitpx-domain': this.parseDomain()
    });
  }

  getBaseHeadersWithoutXitpx(): Headers {
    return new Headers({
      'Content-Type': 'application/pdf'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/domain.service.ts